import { useCallback } from 'react';
import { usePostMaintenanceTicketMutation } from '@/store/api/maintenanceApi';
import { buildTicketFormData } from '@/utils/residents/maintenance/buildTicketFormData';
import { PermissionChoice } from './useMaintenanceForm';

type UploadLike = { uri?: string; type?: string; name?: string; file?: { uri: string; type: string; name: string } };

export interface SubmitArgs {
  maintenanceInfo: any;
  locationName: string;
  categoryName: string;
  subCategoryName: string;
  problemName: string;
  severityName: string;
  description: string;
  phoneNumber: string;
  permissionChoice: PermissionChoice;
  attachments?: UploadLike[];
  petsDescription?: string;
}

export const useSubmitMaintenanceTicket = () => {
  const [submitTicket, status] = usePostMaintenanceTicketMutation();

  const submit = useCallback(async (args: SubmitArgs) => {
    const formData = buildTicketFormData(args as any);
    return submitTicket(formData).unwrap();
  }, [submitTicket]);

  return { submit, status } as const;
};


